/**
 * isUnitFullySold
 *
 * Determines whether a unit's live availability is fully sold across every
 * period cell. Extracted from client-offer-page.tsx to keep that file under
 * the ESLint max-lines limit; shared by both the authenticated and public
 * client-offer-review-v2 unit mappers (map-client-view-to-review-unit.ts).
 */
import type { AvailabilityPeriodCell } from '@ooh/contracts';
import { getCellStateFromPeriod } from './client-offer-availability-helpers';

/** Structural subset both `ClientOfferViewUnit` and `PublicOfferViewUnit` satisfy. */
interface UnitWithAvailability {
  availability: AvailabilityPeriodCell[];
}

export function isUnitFullySold(enriched: UnitWithAvailability | null): boolean {
  return (
    enriched != null &&
    enriched.availability.length > 0 &&
    enriched.availability.every((cell) => getCellStateFromPeriod(cell) === 'sold')
  );
}
